import React from 'react';

const Process: React.FC = () => <section aria-label="process" />;

export default Process;
